const PATIENT_LOG_MESSAGES = {
  patient_created: "Создан пациент",
  patient_created_from_yc: "Создан пациент из YClients",
  patient_contact_updated: "Изменены контактные данные пациента",
  patient_profile_updated: "Изменена медицинская карта пациента",
  patient_docs_deleted: "Удалён документ медкарты",
  patient_recommendations_updated: "Обновлены рекомендации пациента",
  patient_recommendations_template_applied: "К пациенту применен шаблон рекомендаций",
  patient_appointment_marked: "Отмечен прием пациента",
  patient_dynamics_added: "Добавлена запись динамики пациента",
  patient_dynamics_updated: "Обновлена запись динамики пациента",
  patient_dynamics_deleted: "Удалена запись динамики пациента",
  patient_plan_course_added: "В план лечения добавлен курс",
  patient_plan_course_item_removed: "Услуга удалена из курса лечения",
  patient_plan_service_added: "В план лечения добавлена услуга",
  patient_plan_service_deleted: "Из плана лечения удалена услуга",
  patient_plan_subitem_added: "К услуге добавлен состав",
  patient_plan_subitem_deleted: "Из услуги удален элемент состава",
  patient_plan_group_added: "В план лечения добавлена группа услуг",
  patient_plan_group_deleted: "Из плана лечения удалена группа услуг",
  patient_plan_service_updated: "Изменены параметры услуги плана лечения",
  patient_plan_appointment_count_increased: "Увеличено количество приемов в плане лечения",
  patient_plan_appointment_count_decreased: "Уменьшено количество приемов в плане лечения",
  patient_plan_appointment_checked: "Обновлена отметка приема в плане лечения",
  patient_plan_admission_date_set: "Установлена плановая дата приема",
  patient_plan_payment_added: "Добавлена оплата по плану лечения",
  patient_plan_created_from_template: "Создан план лечения из шаблона",
};

export const getPatientLogMessage = (key, fallbackText = "") => {
  if (!key) return fallbackText || "";
  return PATIENT_LOG_MESSAGES[key] || fallbackText || "";
};

const normalizeTextValue = (value) => {
  if (value == null) return "—";
  const normalized = String(value).trim();
  return normalized === "" ? "—" : normalized;
};

const formatChanges = (changes = []) => {
  if (!Array.isArray(changes) || changes.length === 0) return "";

  const prepared = changes
    .filter((change) => change?.label)
    .map((change) => {
      const fromText = normalizeTextValue(change?.from);
      const toText = normalizeTextValue(change?.to);
      return `${change.label}: ${fromText} -> ${toText}`;
    });

  if (prepared.length === 0) return "";

  return prepared.join("; ");
};

export const buildPatientLogText = (key, context = {}) => {
  const baseText = getPatientLogMessage(key, context?.fallbackText || "");
  const changesText = formatChanges(context?.changes);
  const detailsText = normalizeTextValue(context?.details || "");

  if (changesText) return `${baseText}: ${changesText}`;
  if (detailsText !== "—") return `${baseText}: ${detailsText}`;
  return baseText;
};

export default PATIENT_LOG_MESSAGES;
